// extracted by mini-css-extract-plugin
export default {"tcoButton":"_2Vrbi9","tcoButtonDisabled":"_2ccxpt"};